import { useEffect, useState } from 'react';
import { Subscription } from 'rxjs';
import AppRoutes from './AppRoutes';
import DevBar from './components/DevBar/DevBar';
import EnvironmentLabel from './components/EnvironmentLabel/EnvironmentLabel';
import ImpersonationLabel from './components/ImpersonationLabel/ImpersonationLabel';
import { useGeneralContext } from './services/GeneralContext';
import './styles/custom.scss';
import { storeFirstTouchUtm } from './utilities/utm';

const App: React.FC = () => {
  const { refreshAppTrigger$ } = useGeneralContext();

  const [displayApp, setDisplayApp] = useState<boolean>(true);

  useEffect(() => {
    storeFirstTouchUtm();
  }, []);

  useEffect(() => {
    const allSubscriptions = new Subscription();

    // In some cases, like when we impersonate a user, we need to refresh the app's state
    // entirely, so we use a state variable to unmount/remount the app's core components,
    // which will rerun initialization logic
    allSubscriptions.add(
      refreshAppTrigger$.subscribe(() => {
        setDisplayApp(false);

        setTimeout(() => {
          setDisplayApp(true);
        }, 0);
      })
    );

    return () => {
      allSubscriptions.unsubscribe();
    };
  }, [refreshAppTrigger$]);

  return (
    <>
      {displayApp ? (
        <>
          <ImpersonationLabel />

          <DevBar />

          <EnvironmentLabel />

          <AppRoutes />
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default App;
